export default {
  state: {
    modals: {}
  },
  mutations: {
    SHOW_MODAL(state, { name, params }) {
      state.modals[name] = { isOpen: true, params }
    },
    HIDE_MODAL(state, name) {
      if (state.modals[name]) {
        state.modals[name].isOpen = false
      }
    },
    TOGGLE_MODAL(state, { name, params }) {
      if (state.modals[name]) {
        state.modals[name] = { isOpen: !state.modals[name].isOpen, params }
      }
    },
    HIDE_ALL_MODAL(state) {
      Object.keys(state.modals).forEach((name) => {
        if (state.modals[name]) {
          state.modals[name].isOpen = false
        }
      })
    },
    REGISTER_MODAL(state, name) {
      if (!state.modals[name]) {
        state.modals[name] = { isOpen: false, params: null }
      }
    }
  },
  actions: {
    showModal({ commit }, { name, params = {} }) {
      commit('SHOW_MODAL', { name, params })
    },
    hideModal({ commit }, name) {
      commit('HIDE_MODAL', name)
    },
    hideAllModals({ commit }) {
      commit('HIDE_ALL_MODAL')
    },
    toggleModal({ commit }, { name, params = {} }) {
      commit('TOGGLE_MODAL', { name, params })
    },
    registerModal({ commit }, name) {
      commit('REGISTER_MODAL', name)
    }
  },
  getters: {
    isModalOpen: (state) => (name) => state.modals[name]?.isOpen || false,
    getModalParams: (state) => (name) => state.modals[name]?.params || null
  }
}
